import { motion } from "framer-motion";
import Contact from "@/components/Contact";

const ContactPage = () => {
  return (
    <div className="pt-20" data-testid="contact-page">
      {/* Hero Section */}
      <section className="relative py-24 sm:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-600/10 to-transparent" />
        
        <div className="relative max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
          <motion.div
            className="max-w-3xl mx-auto text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-xs sm:text-sm font-bold tracking-[0.2em] uppercase text-blue-400 mb-4 block">
              Contact Us
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-gradient leading-tight mb-6">
              Let's Build Something Amazing
            </h1>
            <p className="text-lg md:text-xl text-slate-300 leading-relaxed">
              Ready to start your project? Get in touch with our team and let's discuss how we can help transform your business.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Section */}
      <Contact />
    </div>
  );
};

export default ContactPage;
